const e = {
  "tnc-checkbox-container": "styles-module__tnc-checkbox-container___XUzMP",
  "terms-and-conditions": "styles-module__terms-and-conditions___uogzJ",
  "tnc-label": "styles-module__tnc-label___FT7gu"
};
export {
  e as default
};
